import SectionHub from '@/components/docs/SectionHub';

export default function DocsHub() {
  return <SectionHub sectionPath="" />;
}
